import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'

function renderAssistedNotice(location) {
  const applicantStates = ['PA']

  if (applicantStates.find(a => a === location.state_acronym)) {
    textContent(
      '.notice-banner__main',
      `Important notice: Agent-assisted applications are not permitted in ${location.state}. Please email the quote directly to your customer to proceed with submission.`
    )
    toggleClass('.notice-banner', 'd-block', true)
  }
}

export default renderAssistedNotice
